import axios from "axios";

export function createAxiosApi(resource, user, config) {
	const api = axios.create({
		baseURL: `${config.apiUrl}/${resource}`
	});

	// Always send credentials so the API can manage HttpOnly cookies for authentication
	api.defaults.withCredentials = true;

	return api;
}
